import { ApolloClient } from '@apollo/client';

/**
 * Re-runs the queries that are currently active, and only those.
 *
 * Skipped queries (`skip: true`, i.e. the ones still waiting for a required id)
 * sit in Apollo's "standby" policy and must stay out: they fetch by themselves
 * as soon as their `skip` turns false. Including them — which is what
 * `reFetchObservableQueries(true)` does — sends each of them with the variables
 * it had while skipped, so the required id is missing: on 29/09/2026 that was
 * three quarters of all GraphQL errors on ss and mdp ("Variable '$surveyId' /
 * '$id' of required type 'ID!' was not provided" on
 * getMyLastSurveyResponseOfSurvey, getCoursePermission, getTheme,
 * getSurveyResponse*), fired on every login.
 */
export const refetchActiveQueries = async (
  client: ApolloClient<any> | null | undefined,
) => {
  if (!client) return;
  if (typeof client.reFetchObservableQueries === 'function') {
    await client.reFetchObservableQueries(false);
  } else if (typeof client.refetchQueries === 'function') {
    await client.refetchQueries({ include: 'active' });
  }
};
